// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body[data-v-6c0806f1]{font-family:\"Nimbus\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",sans-serif;font-weight:400}.total[data-v-6c0806f1]{display:flex;font-size:15px;justify-content:space-between;opacity:.5;padding:.5rem 0 0}.total .note[data-v-6c0806f1]{color:hsla(0,0%,4%,.3);margin-top:.25rem}@media(min-width:768px){.total[data-v-6c0806f1]{padding:.5rem 0 0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
